import { TbLayoutDashboardFilled, TbWallet, TbCode } from "react-icons/tb";
import { FaArrowRightArrowLeft } from "react-icons/fa6";
import { PiBuildingApartmentFill, PiUsersFour } from "react-icons/pi";
import { HiMiniUsers, HiOutlineCloudArrowUp } from "react-icons/hi2";
import { BsFillSendFill } from "react-icons/bs";

const DASHBOARD = {
  Icon: TbLayoutDashboardFilled,
  label: "Dashboard",
  path: "/dashboard",
};
const TRANSACTIONS = {
  Icon: FaArrowRightArrowLeft,
  label: "Transactions",
  path: "/transaction-page",
};
const FUND_TRANSFER = {
  Icon: BsFillSendFill,
  label: "Funds Transfer",
  path: "/funds-transfer",
};
const LIPA_BIDHAA = {
  Icon: TbWallet,
  label: "Lipa Bidhaa",
  path: "/lipa-bidhaa",
};
const MY_COMPANY = {
  Icon: PiBuildingApartmentFill,
  label: "My Company",
  path: "/company-details?tab=company",
};
const USERS_AND_ROLES = {
  Icon: HiMiniUsers,
  label: "Users & Roles",
  path: "/user-role",
};
const MANAGE_ROLES = {
  Icon: HiMiniUsers,
  label: "Manage Roles",
  path: "/manage-roles",
};
const MANAGE_MERCHANTS = {
  Icon: PiUsersFour,
  label: "Manage Merchants",
  path: "/manage-merchants",
};
const DEVELOPER = {
  Icon: TbCode,
  label: "Developer",
  path: "/developer-apis",
};
const BULK_UPLOADS = {
  Icon: HiOutlineCloudArrowUp,
  label: "Bulk Payments",
  path: "/bulkpayments",
};

export const NAV_SECTIONS = {
  ROLE_SUPER_ADMIN: {
    main: [DASHBOARD, TRANSACTIONS, BULK_UPLOADS],
    settings: [MANAGE_ROLES, MANAGE_MERCHANTS],
  },
  ROLE_MERCHANT_ADMIN: {
    main: [DASHBOARD, TRANSACTIONS, FUND_TRANSFER, LIPA_BIDHAA, BULK_UPLOADS],
    settings: [MY_COMPANY, USERS_AND_ROLES, DEVELOPER],
  },
  ROLE_MERCHANT_AGENT: {
    main: [DASHBOARD, TRANSACTIONS],
    settings: [MANAGE_MERCHANTS],
  },
  ROLE_MERCHANT_USER: {
    main: [DASHBOARD, TRANSACTIONS],
    settings: [],
  },
};
